import React from 'react';
import { Box } from '@mui/material';
import SectionLayout from '../layout/SectionLayout';
import { useCompanyData } from '../contexts/DataContext';
import makeStyles from '@mui/styles/makeStyles';
import { SectionTitle as T1SectionTitle, SectionSubtitle as T1SectionSubTitle } from '../../Template1/components/SectionTitle';
import { SectionTitle as T2SectionTitle, SectionSubtitle as T2SectionSubTitle } from '../../Template2/components/SectionTitle';
import { SectionTitle as T3SectionTitle, SectionSubtitle as T3SectionSubTitle } from '../../Template3/components/SectionTitle';
import { SectionTitle as T4SectionTitle, SectionSubtitle as T4SectionSubTitle } from '../../Template4/components/SectionTitle';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import imgServices from 'src/assets/images/templates/t3/services.svg';
import '../../shared/styles.css';
import { Typography } from '@mui/material';
import useRTL from 'src/hooks/useRTL';
import { textVariant, textClasses } from '../config';
import { BGSectionTitle } from '../../Template3/screens/Home'
import '../../shared/styles.css'

const useStyles = makeStyles((theme) => ({
    cardListDiv:{
        display:'flex',
        flexDirection:'column',
        width:"100%",
        margin:"auto",
    },

    accordionRoot: {
        boxShadow: '0px 3px 6px #00000029',
        borderRadius:'0px !important',
        marginBottom:'25px',

        '&::before':{
            display:'none'
        }
    },

    accordionSumRoot:{
        minHeight:'75px',
        padding:'0px 34px',
        [theme.breakpoints.down('md')]: {
            padding:'0px 16px'
        }
    },

    accordDetail:{
        padding:'8px 34px 16px 34px',
        [theme.breakpoints.down('md')]: {
            padding:'8px 16px 16px 16px'
        }
    }
}));

const fontFamilyList = {
  '1': "'Nunito Sans', sans-serif",
  '2': "'Roboto', sans-serif",
  '3': "'Poppins', sans-serif",
  '4': "'Nunito Sans', sans-serif",
};

const TitleList = {
    '1': T1SectionTitle,
    '2': T2SectionTitle,
    '3': T3SectionTitle,
    '4': T4SectionTitle,
};

const SubTitleList = {
    '1': T1SectionSubTitle,
    '2': T2SectionSubTitle,
    '3': T3SectionSubTitle,
    '4': T4SectionSubTitle,
};

export default function Testimonial({ contentData, index }) {
    const { data } = useCompanyData();
    const { isRTL, themeDesign } = data;
    const {backgroundColor, backgroundImage, backgroundStyle, title, arTitle, subTitle, arSubTitle, titleFormat, titleFontSize, subTitleFontSize, titleFontColor, subTitleFontColor, paddingTop, paddingBottom } = contentData || {};
    const classes = useStyles();
  
    const _title = title ? (isRTL === 'ar' ? (arTitle ? arTitle : title) : title) : 'Answers To Questions';
    const _subTitle = subTitle ? (isRTL === 'ar' ? (arSubTitle ? arSubTitle : subTitle) : subTitle) : 'FAQ';
  

    const TitleComponent = TitleList?.[themeDesign];
    const SubTitleComponent = SubTitleList?.[themeDesign];

    return (
      <Box
        style={{
          width:'100%',
          ...(backgroundStyle === 'image' && backgroundImage ?
            {
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundRepeat: 'no-repeat',
            }
            :
            backgroundStyle === 'gradient' ? 
            {backgroundImage: backgroundColor} 
            : {backgroundColor: backgroundColor || '#FAFAFA'}
          )
        }}
      >
        <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <Box width="100%" m="auto" position="relative">

          <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
            <SubTitleComponent pFontSize={subTitleFontSize} color={subTitleFontColor}>{_subTitle}</SubTitleComponent>
            <TitleComponent pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat}>{_title}</TitleComponent>
          </Box>
          <Box className={classes.cardListDiv}>
            {React.Children.toArray(contentData?.cardList.map((v,i)=> {
              if(v.title) {
                  return(
                      <FaqAccordion
                          {...{...v, 
                          title: v.title,
                          arTitle: v.arTitle,
                          description: v.description,
                          arDescription:  v.arDescription,
                          contentData,TitleComponent,index:i}}
                      />
                  )
              }
            }))}
          </Box>
        </Box>
        </SectionLayout>
      </Box>
    );
};


function FaqAccordion(props) {
    const { data } = useCompanyData();
    const { title, description, arTitle, arDescription, contentData, TitleComponent } = props || {};
    const { isRTL, themeDesign } = data || {};
    const { cardTitleFontSize, cardTextFontSize, cardTitleColor, cardTextColor } = contentData || {};
    const classes = useStyles();
    const [, , themeFontFamily] = useRTL('',fontFamilyList?.[themeDesign]);

    const titleFontSize = cardTitleFontSize ? cardTitleFontSize : '21';
    const descriptionFontSize = cardTextFontSize ? cardTextFontSize : '18';
    const titleFontColor = cardTitleColor ? cardTitleColor : '#110729';
    const descFontColor = cardTextColor ? cardTextColor : '#696969';

    const titleText = isRTL === 'ar' && arTitle ? arTitle : title;
    const descriptionText = isRTL === 'ar' && arDescription ? arDescription : description;

    return (
        <Accordion classes={{root:`${classes.accordionRoot}`}}>
            <AccordionSummary
            classes={{root:classes.accordionSumRoot}}
            expandIcon={<ExpandMoreIcon style={{color:titleFontColor}}/>}
            aria-controls="panel1-content"
            id="panel1-header"
            >
                <TitleComponent pb={0} fontWeight="500" noWrap contentSection={true} pFontSize={titleFontSize} {...(titleFontColor ? {color: titleFontColor} : {} )}>
                    {titleText}
                </TitleComponent>
            </AccordionSummary>
            <AccordionDetails classes={{root:classes.accordDetail}}>
                <Typography
                    variant={descriptionFontSize && textVariant?.[descriptionFontSize] ? textVariant?.[descriptionFontSize] : textVariant?.['18']}
                    className={descriptionFontSize && textClasses?.[descriptionFontSize] ? textClasses?.[descriptionFontSize] : textClasses?.['18']}
                    style={{fontFamily:themeFontFamily,color:descFontColor}}
                >
                {descriptionText}
                </Typography>
            </AccordionDetails>
        </Accordion>      
    );
};